// extracted by mini-css-extract-plugin
export default {"pageHeader":"styles_pageHeader__8nXyO","closeButton":"styles_closeButton__HB3wg","text":"styles_text__abQa9","header":"styles_header__Se1cY","subHeader":"styles_subHeader__J3krf"};